module.exports = __webpack_public_path__ + "img/ticket3_w.5380de28.svg";